import axios from '../../utils/axios';

export default function updateLGCollectionTarget(adminId, targetId, data) {
    return (
        axios.post(`/admin/${adminId}/lGCollectionTarget/${targetId}/update`,  data )
    )
}
